import groq from 'groq';

export const GetDocumentQuery = groq`*[_id == $id][0]`;
